import styled from 'styled-components';
import { ifProp, switchProp } from 'styled-tools';
import layoutStyles from 'admin-components/styles/layout';
import StrippedBackElement from 'admin-components/utils/strippedBackElement';

export const StyledText = styled(StrippedBackElement).attrs({
  element: 'span'
})`
  font-size: ${switchProp('size', {
    small: '0.8rem',
    regular: '1rem',
    large: '1.25rem'
  })};
  line-height: ${switchProp('size', {
    small: '1.25rem',
    regular: '1.5rem',
    large: '1.5rem'
  })};
  font-style: ${ifProp('italic', 'oblique', 'normal')};
  font-weight: ${ifProp('bold', '600', '400')};
  white-space: pre-wrap;
  color: ${(props) => props.color || 'inherit'};

  ${layoutStyles};
`;
